import {IconUICard, IconUICash, IconUILegalEntity} from "#components";

export const PAYMENT_CARD = 'card';
export const PAYMENT_CASH = 'cash';
export const PAYMENT_LEGAL_ENTITY = 'legal_entity';
export const PAYMENT_KASPI = 'kaspi';
export const PAYMENT_KASPI_KEY = 'phone_number';

export const PAYMENT_CARD_KEY = 'subscription_id';
export const PAYMENT_LEGAL_ENTITY_KEY = 'legal_entity_id';
export enum PaymentMethod {
    CASH = PAYMENT_CASH,
    LEGAL_ENTITY = PAYMENT_LEGAL_ENTITY,
    CARD = PAYMENT_CARD,
}

export const PaymentMethodWithIcon = [
    {value: PaymentMethod.CASH, icon: IconUICash},
    {value: PaymentMethod.CARD, icon: IconUICard},
    {value: PaymentMethod.LEGAL_ENTITY, icon: IconUILegalEntity}
]

export interface SelectPaymentMethodInterface {
    method: string;
    key:string|null,
    value: string|null;
    options?:any;
}